import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = {
  key: 0,
  class: "absolute inset-0 bg-gray-900 bg-opacity-70 backdrop-blur-sm z-10 flex flex-col items-center justify-center px-0"
}
const _hoisted_2 = { class: "text-center p-1" }
const _hoisted_3 = { class: "px-4 mb-4 flex justify-center sidebar-logo" }
const _hoisted_4 = {
  class: "flex-1 px-2 space-y-1 overflow-y-auto scrollbar-hide sidebar-nav",
  style: {"scrollbar-width":"none","-ms-overflow-style":"none"}
}
const _hoisted_5 = {
  key: 0,
  class: "sidebar-text"
}
const _hoisted_6 = {
  key: 1,
  class: "tooltip"
}
const _hoisted_7 = {
  key: 0,
  class: "sidebar-text"
}
const _hoisted_8 = {
  key: 1,
  class: "tooltip"
}
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = {
  key: 0,
  class: "sidebar-text"
}
const _hoisted_11 = {
  key: 1,
  class: "tooltip"
}
const _hoisted_12 = {
  key: 0,
  class: "ml-1 text-red-400"
}
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = {
  key: 0,
  class: "sidebar-text"
}
const _hoisted_16 = {
  key: 1,
  class: "tooltip"
}
const _hoisted_17 = {
  key: 0,
  class: "ml-1 text-red-400"
}
const _hoisted_18 = {
  key: 0,
  class: "sidebar-text"
}
const _hoisted_19 = {
  key: 1,
  class: "tooltip"
}
const _hoisted_20 = {
  key: 0,
  class: "sidebar-text"
}
const _hoisted_21 = {
  key: 1,
  class: "tooltip"
}
const _hoisted_22 = {
  key: 0,
  class: "sidebar-text"
}
const _hoisted_23 = {
  key: 1,
  class: "tooltip"
}
const _hoisted_24 = {
  key: 0,
  class: "sidebar-text"
}
const _hoisted_25 = {
  key: 1,
  class: "tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NotificationDropdown = _resolveComponent("NotificationDropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar-container h-screen fixed left-0 top-0 z-20 transition-all duration-300", {
      'w-64': _ctx.isOpen && _ctx.isAuthenticated && !_ctx.isMobile,
      'w-16': !_ctx.isOpen || !_ctx.isAuthenticated || _ctx.isMobile,
    }])
  }, [
    (!_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-white text-xs mb-2" }, "Prijavi se", -1)),
            _createVNode(_component_router_link, {
              to: "/login",
              class: "block bg-indigo-600 text-white rounded-md hover:bg-indigo-500 transition-colors text-center w-full py-2"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-6 w-6 mx-auto",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M3 3a1 1 0 011-1h12a1 1 0 011 1v14a1 1 0 01-1 1H4a1 1 0 01-1-1V3zm2 0v14h12V3H5z",
                    "clip-rule": "evenodd"
                  }),
                  _createElementVNode("path", { d: "M11 6a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6z" })
                ], -1)
              ])),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["h-full bg-gray-800 text-white flex flex-col shadow-lg relative sidebar-content", { 'blur-sm': !_ctx.isAuthenticated }])
    }, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
        class: _normalizeClass(["absolute -right-3 bg-gray-700 rounded-full p-1 text-white shadow-md toggle-button hidden md:block", { hidden: !_ctx.isAuthenticated }])
      }, [
        (_openBlock(), _createElementBlock("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: _normalizeClass(["h-5 w-5", { 'rotate-180': !_ctx.isOpen }]),
          viewBox: "0 0 20 20",
          fill: "currentColor"
        }, _cache[6] || (_cache[6] = [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
            "clip-rule": "evenodd"
          }, null, -1)
        ]), 2))
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "block hover:opacity-80 transition-opacity"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Logo",
              class: "h-12 sm:h-12"
            }, null, -1)
          ])),
          _: 1
        })
      ]),
      _createElementVNode("nav", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/create-product",
          class: "sidebar-link group relative",
          "active-class": "sidebar-link-active"
        }, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: _normalizeClass([isActive ? 'sidebar-link-active' : 'sidebar-link'])
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "sidebar-icon",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
                  "clip-rule": "evenodd"
                })
              ], -1)),
              (_ctx.isOpen && !_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Dodaj novi oglas"))
                : _createCommentVNode("", true),
              (!_ctx.isOpen || _ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Dodaj novi oglas "))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/my-listings",
          class: "sidebar-link group relative",
          "active-class": "sidebar-link-active"
        }, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: _normalizeClass([isActive ? 'sidebar-link-active' : 'sidebar-link'])
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "sidebar-icon",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", { d: "M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z" })
              ], -1)),
              (_ctx.isOpen && !_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Moji oglasi"))
                : _createCommentVNode("", true),
              (!_ctx.isOpen || _ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Moji oglasi"))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/messages",
          class: "sidebar-link group relative",
          "active-class": "sidebar-link-active"
        }, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: _normalizeClass([isActive ? 'sidebar-link-active' : 'sidebar-link'])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _cache[10] || (_cache[10] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "sidebar-icon",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", { d: "M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" }),
                  _createElementVNode("path", { d: "M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" })
                ], -1)),
                (_ctx.hasUnreadMessages)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center font-medium", { 'animate-pulse': _ctx.hasNewNotification }])
                    }, _toDisplayString(_ctx.badges.messages > 9 ? '9+' : _ctx.badges.messages), 3))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isOpen && !_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Poruke"))
                : _createCommentVNode("", true),
              (!_ctx.isOpen || _ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[11] || (_cache[11] = _createTextVNode(" Poruke ")),
                    (_ctx.hasUnreadMessages)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(" + _toDisplayString(_ctx.badges.messages) + ")", 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleNotifications && _ctx.toggleNotifications(...args))),
            class: _normalizeClass(["sidebar-link group w-full text-left relative", { 'sidebar-link-active bg-gray-900': _ctx.showNotifications }])
          }, [
            _createElementVNode("div", _hoisted_14, [
              _cache[12] || (_cache[12] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "sidebar-icon",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", { d: "M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" })
              ], -1)),
              (_ctx.totalBadgeCount > 0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center font-medium", { 'animate-pulse': _ctx.hasNewNotification }])
                  }, _toDisplayString(_ctx.totalBadgeCount > 9 ? '9+' : _ctx.totalBadgeCount), 3))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass(["absolute -bottom-1 -right-1 w-2 h-2 rounded-full border border-gray-800", {
                  'bg-green-500': _ctx.isConnected,
                  'bg-red-500': !_ctx.isConnected && _ctx.connectionError,
                  'bg-yellow-500': !_ctx.isConnected && !_ctx.connectionError,
                }])
              }, null, 2)
            ]),
            (_ctx.isOpen && !_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Obaveštenja"))
              : _createCommentVNode("", true),
            (!_ctx.isOpen || _ctx.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[13] || (_cache[13] = _createTextVNode(" Obaveštenja ")),
                  (_ctx.totalBadgeCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "(" + _toDisplayString(_ctx.totalBadgeCount) + ")", 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode(_component_NotificationDropdown, {
            show: _ctx.showNotifications && _ctx.isAuthenticated,
            "is-sidebar-open": _ctx.isOpen && !_ctx.isMobile,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showNotifications = false))
          }, null, 8, ["show", "is-sidebar-open"])
        ]),
        _createVNode(_component_router_link, {
          to: "/ratings",
          class: "sidebar-link group relative",
          "active-class": "sidebar-link-active"
        }, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: _normalizeClass([isActive ? 'sidebar-link-active' : 'sidebar-link'])
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "sidebar-icon",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" })
              ], -1)),
              (_ctx.isOpen && !_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Ocene"))
                : _createCommentVNode("", true),
              (!_ctx.isOpen || _ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Ocene"))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/following",
          class: "sidebar-link group relative",
          "active-class": "sidebar-link-active"
        }, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: _normalizeClass([isActive ? 'sidebar-link-active' : 'sidebar-link'])
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "sidebar-icon",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
                  "clip-rule": "evenodd"
                })
              ], -1)),
              (_ctx.isOpen && !_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Pratim"))
                : _createCommentVNode("", true),
              (!_ctx.isOpen || _ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Pratim"))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/account",
          class: "sidebar-link group relative",
          "active-class": "sidebar-link-active"
        }, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("div", {
              class: _normalizeClass([isActive ? 'sidebar-link-active' : 'sidebar-link'])
            }, [
              _cache[16] || (_cache[16] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "sidebar-icon",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                  "clip-rule": "evenodd"
                })
              ], -1)),
              (_ctx.isOpen && !_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Moj nalog"))
                : _createCommentVNode("", true),
              (!_ctx.isOpen || _ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Moj nalog"))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
          class: "sidebar-link group w-full text-left relative"
        }, [
          _cache[17] || (_cache[17] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "sidebar-icon",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M3 3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V7.414l-4-4H3zm7 2a1 1 0 011 1v6.414l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L12 12.414V6a1 1 0 011-1h2a1 1 0 110 2h-1v.586l1.707 1.707A1 1 0 0016 10v5a3 3 0 01-3 3H5a3 3 0 01-3-3V5a3 3 0 013-3h5a1 1 0 010 2H5v-.001z",
              "clip-rule": "evenodd"
            })
          ], -1)),
          (_ctx.isOpen && !_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Izloguj se"))
            : _createCommentVNode("", true),
          (!_ctx.isOpen || _ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Izloguj se"))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ], 2))
}